import { GlBadge, GlLink, GlTooltipDirective } from '@gitlab/ui';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { generateText } from './utils';
import ContentRow from './widget_content_row.vue';
import Actions from './action_buttons.vue';
export default {
    name: 'DynamicContent',
    components: {
        GlBadge,
        GlLink,
        Actions,
        ContentRow
    },
    directives: {
        SafeHtml,
        GlTooltip: GlTooltipDirective
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        widgetName: {
            type: String,
            required: true
        },
        level: {
            type: Number,
            required: false,
            default: 2
        },
        rowIndex: {
            type: Number,
            required: false,
            default: -1
        }
    },
    emits: [
        'clicked-action'
    ],
    computed: {
        statusIcon () {
            return this.data.icon?.name || undefined;
        },
        generatedText () {
            return generateText(this.data.text);
        },
        generatedSubtext () {
            return generateText(this.data.subtext);
        },
        generatedSupportingText () {
            return generateText(this.data.supportingText);
        },
        shouldShowThirdLevel () {
            return this.data.children?.length > 0 && this.level === 2;
        },
        hasActionButtons () {
            return this.data.actions?.length > 0;
        }
    },
    methods: {
        onClickedAction (action) {
            this.$emit('clicked-action', action);
        }
    }
};
